import React from 'react';
// import { Bot } from 'lucide-react';
import CheckPage from './CheckPage';

const AICheckPage: React.FC = () => {
  return (
    <CheckPage
      title="AI Content Detection"
      subtitle="Detect AI-generated content in submitted manuscripts"
      accentColor="#003c6c"
      scoreLabel="AI Content"
      checkTypes={[{ key: 'ai', label: 'AI Detection' }]}
    />
  );
};

export default AICheckPage;